import { AssetTypes } from "./types";

/**
 * Converts a camelCased asset type enum value to a sentence cased string.
 * Useful for displaying asset types in tooltips and UI labels.
 *
 * @example
 * assetTypeToSentenceCase(AssetTypes.TableView) // "Table view"
 * assetTypeToSentenceCase(AssetTypes.Zap) // "Zap"
 * assetTypeToSentenceCase(AssetTypes.TableSubscription) // "Table subscription"
 */
export const assetTypeToSentenceCase = (assetType: AssetTypes): string => {
  // Insert a space before each uppercase letter and convert to lowercase
  const withSpaces = assetType.replaceAll(/([A-Z])/g, " $1").trim();

  // Capitalize only the first character (sentence case)
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).toLowerCase();
};
